<template>
  <div class="ele-body">
    <el-card class="analysis-chart-card" style="margin-bottom: 15px">
      <div slot="header">
        <span>短信数据详情</span>
      </div>
      <div class="analysis-chart-card-sms">
        <ele-chart ref="schoolAllecharts" :option="smsOption" style="height: 400px" />
      </div>
    </el-card>
  </div>
</template>

<script>
  import EleChart from '@/components/EleChart';
  import { getMessageData } from '@/config/api';

  export default {
    name: 'Index',
    components: { EleChart },
    data() {
      return {
        smsInfo: [],
      };
    },
    computed: {
      smsOption() {
        return {
          legend: {},
          tooltip: {},
          xAxis: {
            type: 'category',
            data: ['购买总数', '购买金额', '已发送数量', '剩余短信'],
          },
          yAxis: {
            type: 'value',
          },
          series: [
            {
              data: this.smsInfo,
              type: 'bar',

              label: {
                show: true,
                position: 'top',
                textStyle: {
                  color: '#2f89cf',
                },
              },
            },
          ],
        };
      },
    },
    created() {
      getMessageData().then((res) => {
        if (res.data.resCode == 200) {
          this.smsInfo = [
            res.data.data.schoolMessage.buyTotal,
            res.data.data.schoolMessage.buyMoney,
            res.data.data.schoolMessage.sendTotal,
            res.data.data.schoolMessage.surplusTotal,
          ];
        }
      });
    },
    methods: {},
  };
</script>

<style scoped>
  .analysis-chart-card-sms {
    height: 400px;
    box-sizing: border-box;
    margin-bottom: 12px;
  }
</style>
